import React from 'react';
import ServicesLayout from '../../../components/ServicesLayout';
import DistrictDeclarations from './DistrictDeclarations';
import { isAdminUser, isDistrictAdminUser } from '../../../lib/utils';

const title = 'Deklaracje dostępności';


export default {

  path: '/district_declarations',
  children: [
    {
      path: '/',
      async action(ctx) {
        const state = await ctx.store.getState();
        const isAdmin = await isAdminUser(ctx);
        let isDistrictAdmin = null;
        if (!isAdmin) {
          isDistrictAdmin = await isDistrictAdminUser(ctx);
          if (!isDistrictAdmin) {
            return { redirect: '/' };
          }
        }
        return {
          title,
          chunk: 'ServiceCards',
          component: <ServicesLayout isAdmin><DistrictDeclarations title={title} isDistrictAdmin={isDistrictAdmin} user={state.user} /></ServicesLayout>,
        };
      },
    },
  ],
};



// WEBPACK FOOTER //
// src/routes/admin/district_declarations/index.js